<template>
  <div class="crm-container">
    <!-- <el-container> -->
    <el-container>
      <el-aside width="auto">
        <crm-aside @handleAdd="handleQuickAdd"></crm-aside>
      </el-aside>
      <el-main>
        <slot></slot>
      </el-main>
      <div
        class="quick-add-wrap"
        v-show="
          addCustomVisible ||
            isAddBusiVisible ||
            addCompactDialogVisible ||
            addClueVisible
        "
        @click="handleClose"
      >
        <div class="content" @click="handleStopHideDialog">
          <!-- 新增客户 -->
          <add-custom
            v-if="addCustomVisible"
            @closeAddCustom="addCustomVisible = false"
            @saveAddCustom="addCustomVisible = false"
          >
          </add-custom>

          <!-- 添加商机弹窗 -->
          <add-busi
            v-if="isAddBusiVisible"
            :visible="isAddBusiVisible"
            @close="isAddBusiVisible = false"
            @success="isAddBusiVisible = false"
          >
          </add-busi>

          <!-- 新增合同弹窗 -->
          <add-compact
            v-if="addCompactDialogVisible"
            @close="addCompactDialogVisible = false"
            @success="addCompactDialogVisible = false"
          >
          </add-compact>

          <add-clue
            :visible="addClueVisible"
            @close="addClueVisible = false"
            @success="addClueVisible = false"
          >
          </add-clue>
        </div>
      </div>
    </el-container>
    <!-- </el-container> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CrmHeader from '@/components/layouts/crmHeader';
import CrmAside from '@/components/layouts/crmAside';
import AddCustom from '@/components/business/custom/addCustom';
import AddCompact from '@/components/business/compact/AddCompact.vue';
import AddBusi from '@/components/business/busiopportunity/addBusi';
import AddClue from '@/components/business/clue/add';
import NoComponent from '@/pages/base/404';

export default {
  components: {
    CrmHeader,
    CrmAside,
    AddBusi,
    AddCustom,
    AddCompact,
    AddClue,
    NoComponent,
  },
  data() {
    return {
      addCustomVisible: false,
      isAddBusiVisible: false,
      addCompactDialogVisible: false,
      addClueVisible: false,
    };
  },
  computed: {
    ...mapGetters('authority', {
      authenticated: 'authenticated',
    }),
  },
  methods: {
    handleQuickAdd(type) {
      switch (type) {
        case 'custom':
          this.addCustomVisible = true;
          break;
        case 'busi':
          this.isAddBusiVisible = true;
          break;
        case 'contract':
          this.addCompactDialogVisible = true;
          break;
        case 'clue':
          this.addClueVisible = true;
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.addCustomVisible = false;
      this.isAddBusiVisible = false;
      this.addCompactDialogVisible = false;
      this.addClueVisible = false;
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-container {
  display: flex;
  flex: 1;
  height: calc(100vh - 50px);
  .el-container {
    overflow: auto;
    width: 100vw;
    .quick-add-wrap {
      position: absolute;
      width: 100%;
      height: calc(100% - 50px);
      .content {
        position: relative;
        height: 100%;
        width: calc(100% - 200px);
        margin-left: 200px;
      }
    }
  }
  .el-aside {
    background: url(../../images/home/navbg.png) no-repeat bottom,
      linear-gradient(@nav-bg--light, @nav-bg--dark);
    background: url(../../images/home/navbg.png) no-repeat bottom,
      -moz-linear-gradient(@nav-bg--light, @nav-bg--dark);
  }
  .el-main {
    position: relative;
    display: flex;
    padding: 20px;
  }
  .el-header {
    padding: 0;
  }
}
</style>
